const baseApiUrl = import.meta.env.VITE_API_URL;

if (!baseApiUrl) {
  console.error('VITE_API_URL is not defined in environment variables');
}

const queryKeys = {
  authKey: 'Auth',
  brandingKey: 'Branding',
  campaignsKey: 'Campaigns',
  companyKey: 'Company',
  deviceKey: 'Device',
  interactionsDictionaryKey: 'InteractionsDictionary',
  interactionsKey: 'Interactions',
  meKey: 'Me',
  themesKey: 'Themes',
  userKey: 'User',
} as const;

const persistConfig = {
  key: 'PLAYWALL_OFFLINE_CACHE',
} as const;

const endpoints = {
  auth: {
    activate: '/auth/activate',
    changePassword: '/auth/change-password',
    forgotPassword: '/auth/forgot-password',
    login: '/auth/login',
    logout: '/auth/logout',
    register: '/auth/register',
    resendActivation: '/auth/resend-activation-link',
    resetPassword: '/auth/reset-password',
  },
  branding: {
    add: '/branding/add',
    delete: (id: number) => `/branding/${id}`,
    getAll: '/branding',
    getDetails: (id: number) => `/branding/${id}`,
    update: (id: number) => `/branding/${id}`,
  },
  campaigns: {
    add: '/campaigns/add',
    addSlot: '/campaigns/slot/add',
    delete: (id: number) => `/campaigns/${id}`,
    deleteSlot: (id: number) => `/campaigns/slot/delete/${id}`,
    dictionaries: '/campaigns/dictionaries',
    editSlot: (id: number) => `/campaigns/slot/edit/${id}`,
    getAll: '/campaigns',
    getDetails: (id: number) => `/campaigns/${id}`,
    update: (id: number) => `/campaigns/edit/${id}`,
  },
  company: {
    add: '/company/add',
    delete: (id: number) => `/company/${id}`,
    getAll: '/company',
    update: (id: number) => `/company/${id}`,
  },
  device: {
    add: '/device/add',
    delete: (id: number) => `/device/delete/${id}`,
    getAll: '/device',
    getDetails: (id: number) => `/device/${id}`,
  },
  interactions: {
    add: '/interaction/add',
    delete: (id: number) => `/interaction/${id}`,
    getAll: '/interaction',
    getDetails: (id: number) => `/interaction/${id}`,
    update: (id: number) => `/interaction/edit/${id}`,
  },
  interactionsDictionary: {
    add: '/interactions-dictionary/add',
    delete: (id: number) => `/interactions-dictionary/${id}`,
    getAll: '/interactions-dictionary',
    getDetails: (id: number) => `/interactions-dictionary/${id}`,
    update: (id: number) => `/interactions-dictionary/${id}`,
  },
  themes: {
    add: '/theme/add',
    delete: (id: number) => `/theme/${id}`,
    getAll: '/theme',
    getDetails: (id: number) => `/theme/${id}`,
  },
  user: {
    delete: (id: number) => `/users/${id}`,
    deleteMe: '/users/delete/me',
    editMe: '/users/edit/me',
    getAll: '/users',
    getDetails: (id: number) => `/users/${id}`,
    getMe: '/users/me',
    update: (id: number) => `/users/${id}`,
  },
} as const;

export { baseApiUrl, endpoints, persistConfig, queryKeys };
